import { ca } from '@cian/analytics';

export function trackShowSpecialPromos() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'CardBuilder',
    action: 'show_promotions_builder',
    useLastProducts: true,
  });
}
